module.exports = __webpack_public_path__ + "media/images/abc-7bf7f8b70cf5091332b28c826ea1a9cc904dd62ce349373df85bf92851fc1de0.png";